import { BorderRadiusTokens, IconSizeTokens, IconTokens, ShimmerIconSizeTokens, SizeTypeTokens, } from '@voltmoney/schema';
export const args = {
    icon: {
        name: IconTokens.ContractFile,
        size: IconSizeTokens.XXXXXXXXL,
    },
    borderRadius: BorderRadiusTokens.BR0,
    padding: SizeTypeTokens.SM,
};
export const argTypes = {
    size: {
        control: 'select',
        options: [
            ...Object.values(ShimmerIconSizeTokens),
        ],
    },
};
